document.addEventListener('DOMContentLoaded', () => {
    const init = () => {
        document.documentElement.removeAttribute('style');
        document.documentElement.classList.add('is-loaded');
        setTimeout(() => {
            window.carousels();
            document.getElementById('cover').remove();
        }, 250);  
    };
    window.addEventListener('load', init);

}, false);